const Footer = {
  invoke: {
    hide() {
      const footerElement = window.document.getElementById('footer');
      if (footerElement) {
        footerElement.className = 'footer--hidden';
        setTimeout(() => footerElement.remove(), 1100);
      }
    },
    show() {
      const footerElement = window.document.getElementById('footer');
      if (footerElement) {
        setTimeout(() => (footerElement.className = 'footer--visible'), 500);
      }
    },
  },
};

export default Footer;
